import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { useState } from "react";
import { useStockItems } from "@/hooks/useStockItems";
import { StockContent } from "@/components/stock/StockContent";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useInventoryState } from "@/hooks/useInventoryState";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AddProductDialog } from "@/components/interface/AddProductDialog";

const Stock = () => {
  const { data: stockItems, isLoading, error, refetch } = useStockItems();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Toutes les catégories");
  const { isInventoryActive, setIsInventoryActive } = useInventoryState();
  const [isAddProductDialogOpen, setIsAddProductDialogOpen] = useState(false);

  // Afficher un message d'erreur si nécessaire
  if (error) {
    console.error("Erreur lors du chargement du stock:", error);
    toast.error("Une erreur est survenue lors du chargement du stock");
  }

  const handleAddProduct = (product: any) => {
    refetch();
    setIsAddProductDialogOpen(false);
    toast.success("Produit ajouté avec succès");
  };

  return (
    <DashboardLayout userType="owner" isInventoryActive={isInventoryActive}>
      <TooltipProvider>
        <div className="space-y-6">
          <PageTitle
            title="Gestion du stock"
            subtitle="Gérez votre inventaire et suivez vos produits"
          />
          
          {isLoading ? (
            <div className="flex items-center justify-center h-64">
              <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
          ) : !stockItems || stockItems.length === 0 ? (
            <div className="space-y-4">
              <div className="flex justify-end">
                <Button onClick={() => setIsAddProductDialogOpen(true)}>
                  <Plus className="w-4 h-4 mr-2" />
                  Ajouter un produit
                </Button>
              </div>
              <div className="text-center p-8 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-gray-600">
                  Aucun produit dans le stock. Commencez par ajouter des produits.
                </p>
              </div>
            </div>
          ) : (
            <StockContent
              stockItems={stockItems}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              refetch={refetch}
              onInventoryStateChange={setIsInventoryActive}
            />
          )}

          <AddProductDialog
            isOpen={isAddProductDialogOpen}
            onOpenChange={setIsAddProductDialogOpen}
            onSubmit={handleAddProduct}
          />
        </div>
      </TooltipProvider>
    </DashboardLayout>
  );
};

export default Stock;